<i18n>
  {
    "pt_BR": {
      "option": "Selecione uma opção",
      "name": "Nome:",
      "phone": "Celular:",
      "country": {
        "label": "País",
        "bra": "Brasil"
      }
    }
  }
</i18n>

<template>
  <div class="signup-form--step step-1 active">
    <div class="signup-input--container">
      <label v-t="'name'"></label>
      <input type="text" class="signup-input--field" required v-model="form.name">
      <p class="signup-input--error active" :key="message" v-text="message" v-for="message in form.error('name')"></p>
      <p class="login-input--error" v-if="! form.has('name')"></p>
    </div>

    <div class="signup-input--container">
      <label>Email:</label>
      <input type="text" class="signup-input--field" required v-model="form.email">
      <p class="signup-input--error active" :key="message" v-text="message" v-for="message in form.error('email')"></p>
      <p class="login-input--error" v-if="! form.has('email')"></p>
    </div>

    <div class="signup-input--container">
      <label v-t="'phone'"></label>
      <the-mask class="signup-input--field" required v-model="form.phone" :mask="['(##) ####-####', '(##) #####-####']" />
      <p class="signup-input--error active" :key="message" v-text="message" v-for="message in form.error('phone')"></p>
      <p class="login-input--error" v-if="! form.has('phone')"></p>
    </div>

    <div class="signup-input--container">
      <label v-t="'country.label'"></label>
      <select id="signupUtilizaRD" class="signup-input--select" v-model="form.country">
        <option value="" disabled selected v-t="'option'"></option>
        <option value="BRA" v-t="'country.bra'"></option>
      </select>
      <p class="signup-input--error active" :key="message" v-text="message" v-for="message in form.error('country')"></p>
      <p class="login-input--error" v-if="! form.has('country')"></p>
    </div>
  </div>
</template>

<script>
  import { TheMask } from 'vue-the-mask'

  export default {
    props: {
      form: {
        required: true,
      },
    },

    components: {
      TheMask,
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Auth/Steps/First.vue